export const getFormatDate = (date: Date, locale: string): string =>
  new Intl.DateTimeFormat(locale).format(date);
